import { ConfirmationDocument } from "src/app/services/apis/web-api-client";

export const ConfirmationDocumentTypes = [
  {type: ConfirmationDocument.Certificate, text: "Сертификат"},
  { type: ConfirmationDocument.CertificateOfProfessionalDevelopment, text: "Свидетельство о повышении квалификации"},
  { type: ConfirmationDocument.DiplomaOfProfessionalRetraining, text: "Диплом о профессиональной переподготовке"},
];

export function GetConfirmationDocumentType(item: ConfirmationDocument) {
  return ConfirmationDocumentTypes.find(x => x.type === item).text || 'Не указано'
};
